
// Vendor
import { Component, Vue, Watch } from 'vue-property-decorator';

// Internal
import { store, StoreMutations, FiltriOrdini } from '@/store';
import { ItemDatiLookup } from '../models';
import { FilterCampionarioProduzione } from '@/models';

@Component
export default class OpzioniOrdini extends Vue {

  @Watch("$store.state.ui.opzioniVisibili")
  onOpzioniOpened(isOpenNew: boolean, isOpenOld: any) {
      if(isOpenNew && isOpenNew != isOpenOld) {
          // caricamento filtro corrente
          this.soloUSA = store.state.uiOrdini.filtri.soloUSA;
          this.campionarioProduzione = store.state.uiOrdini.filtri.campionarioEProduzione;
          this.mostraCompletati = store.state.uiOrdini.filtri.mostraCompletati;
          this.filtroNumOrdine = store.state.uiOrdini.filtri.numOrdine;
          this.filtroModelli = store.state.uiOrdini.filtri.filtroModelli;
          this.filtroStagioni = store.state.uiOrdini.filtri.filtroStagioni;
          this.filtroFasi = store.state.uiOrdini.filtri.filtroFasi;
      }
  }
  campionarioProduzione: any = {
      label:"Campionario e produzione",
      value: FilterCampionarioProduzione.CampionarioEProduzione
    };
  soloUSA: boolean = false;
  soloCampionario: boolean = false;
  mostraCompletati: boolean = false;
  filtroNumOrdine: string = '';
  filtroCodLAK: string = '';

  searchModello: string = '';
  filtroModelli: string[] = [];
  searchStagione: string = '';
  filtroStagioni: string[] = [];
  searchFase: string = '';
  filtroFasi: string[] = [];
  filtroPartita: string = '';

  opzioniCampionarioProduzione: any = [
    {
      label:"Campionario e produzione",
      value: FilterCampionarioProduzione.CampionarioEProduzione
    },
    {
      label:"Solo produzione",
      value: FilterCampionarioProduzione.SoloProduzione
    },
    {
      label:"Solo campionario",
      value: FilterCampionarioProduzione.SoloCampionario
    }
  ]

  get modelliFiltrati(): ItemDatiLookup[] {
    if(store.state.datiLookup && store.state.datiLookup.modelli) {
      return store.state.datiLookup.modelli.filter((e:ItemDatiLookup) => (e.desc || '')
        .toLowerCase()
        .indexOf((this.searchModello || '').toLowerCase()) > -1
      );
    }
    return [];
  }

  get stagioniFiltrate(): ItemDatiLookup[] {
    if(store.state.datiLookup && store.state.datiLookup.stagioni) {
      return store.state.datiLookup.stagioni.filter((e:ItemDatiLookup) => (e.desc || '')
        .toLowerCase()
        .indexOf((this.searchStagione || '').toLowerCase()) > -1
      );
    }
    return [];
  }

  get fasiFiltrate(): ItemDatiLookup[] {
    if(store.state.datiLookup && store.state.datiLookup.fasi) {
      return store.state.datiLookup.fasi.filter((e:ItemDatiLookup) => (e.desc || '')
        .toLowerCase()
        .indexOf((this.searchFase || '').toLowerCase()) >-1
      );
    }
    return [];
  }

  private annullaModificaFiltro() {
    store.commit(StoreMutations.SetOpzioniVisibili, false);
  }

  private applicaModificaFiltro() {
    const filtri: FiltriOrdini = {
      soloUSA: this.soloUSA,
      campionarioEProduzione: this.campionarioProduzione,
      mostraCompletati: this.mostraCompletati,
      numOrdine: this.filtroNumOrdine,
      filtroModelli: this.filtroModelli,
      filtroStagioni: this.filtroStagioni,
      filtroFasi: this.filtroFasi,
      filtroPartita: this.filtroPartita
    };

    store.commit(StoreMutations.SetFiltriOrdini, filtri);
    store.commit(StoreMutations.SetOpzioniVisibili, false);
  }

  private svuotaFiltro() {
    this.soloUSA = false;
    this.campionarioProduzione = FilterCampionarioProduzione.CampionarioEProduzione;
    this.soloCampionario = false;
    this.mostraCompletati = false;
    this.filtroNumOrdine = '';
    this.filtroCodLAK = '';
    this.filtroModelli = [];
    this.filtroStagioni = [];
    this.filtroFasi = [];
    this.filtroPartita = '';
  }
}
